const ITEMS = ["Jual / Beli / Sewa Gudang", "Kontraktor • Jasa Konstruksi • Pabrikasi", "Site Plan • Gambar Kerja • Konsultasi PBG", "Bahan Material", "Sewa Alat & Perlengkapan", "Jasa Logistik Antar Galaksi", "Pengembangan Properti"];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div data-testid="marquee-section" className="relative overflow-hidden border-y border-[#28303f] bg-[#0f131a] py-6">
      <div className="marquee-track items-center gap-0">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0 items-center">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className={`font-display px-8 text-3xl font-bold uppercase tracking-wide sm:text-4xl ${i % 2 === 0 ? "text-slate-200" : "text-stroke"}`}>
                  {item}
                </span>
                <span className="h-2 w-2 rotate-45 bg-amber-400" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
